import {FC, useEffect, useState} from "react";
import {stringToCurrency, zeroToEmptyStringAsCurrency} from "../../common";
import {Form, Table} from "react-bootstrap";

interface DailyFullReportHristoProps {
    hristoBankOut: number;
    hristoBankIn: number;
    hristoCashOut: number;
    hristoCashIn: number;
    onChange: (bankOut: number, bankIn: number, cashOut: number, cashIn: number) => void;
    isBgnMode: boolean;
    currencyRate: number;
}

const DailyFullReportHristo: FC<DailyFullReportHristoProps> = ({
                                             hristoBankOut,
                                             hristoBankIn,
                                             hristoCashOut,
                                             hristoCashIn,
                                             onChange,
                                             isBgnMode,
                                             currencyRate
                                         }: DailyFullReportHristoProps) => {
    const formatValue = (value: number) => {
        const converted = value * currencyRate;
        return zeroToEmptyStringAsCurrency(converted.toString());
    };

    const [bankOut, setBankOut] = useState<string>(formatValue(hristoBankOut));
    const [bankIn, setBankIn] = useState<string>(formatValue(hristoBankIn));
    const [cashOut, setCashOut] = useState<string>(formatValue(hristoCashOut));
    const [cashIn, setCashIn] = useState<string>(formatValue(hristoCashIn));

    useEffect(() => {
        setBankOut(formatValue(hristoBankOut));
        setBankIn(formatValue(hristoBankIn));
        setCashOut(formatValue(hristoCashOut));
        setCashIn(formatValue(hristoCashIn));
    }, [hristoBankIn, hristoBankOut, hristoCashOut, hristoCashIn, currencyRate]);

    const updateParent = () => {
        if (isBgnMode) {
            return;
        }
        onChange(
            stringToCurrency(bankOut) ?? 0,
            stringToCurrency(bankIn) ?? 0,
            stringToCurrency(cashOut) ?? 0,
            stringToCurrency(cashIn) ?? 0
        );
    };

    return (
        <table className="table table-sm table-bordered table-no-padding w-100" style={{fontSize: "0.75rem"}}>
            <thead className={"text-center"}>
            <tr>
                <th colSpan={2}>БАНКА</th>
                <th colSpan={2}>КАСА</th>
            </tr>
            <tr>
                <th>Банкови тегления</th>
                <th>Банкови внасяния</th>
                <th>Отчетени пари</th>
                <th>Върнати пари</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    <Form.Control
                        size={"sm"}
                        className={"text-end border-0 p-0 m-0"}
                        type="number"
                        value={bankOut}
                        disabled={isBgnMode}
                        onChange={(e) => {
                            setBankOut(e.target.value);
                        }}
                        onBlur={updateParent}
                    />
                </td>
                <td>
                    <Form.Control
                        size={"sm"}
                        className={"text-end border-0 p-0 m-0"}
                        type="number"
                        value={bankIn}
                        disabled={isBgnMode}
                        onChange={(e) => {
                            setBankIn(e.target.value);
                        }}
                        onBlur={updateParent}
                    />
                </td>
                <td>
                    <Form.Control
                        size={"sm"}
                        className={"text-end border-0 p-0 m-0"}
                        type="number"
                        value={cashOut}
                        disabled={isBgnMode}
                        onChange={(e) => {
                            setCashOut(e.target.value);
                        }}
                        onBlur={updateParent}
                    />
                </td>
                <td>
                    <Form.Control
                        size={"sm"}
                        className={"text-end border-0 p-0 m-0"}
                        type="number"
                        value={cashIn}
                        disabled={isBgnMode}
                        onChange={(e) => {
                            setCashIn(e.target.value);
                        }}
                        onBlur={updateParent}
                    />
                </td>
            </tr>
            </tbody>
        </table>
    );
}

export default DailyFullReportHristo;
